import { type UUID } from '~/types/common';

export const queryKeysCompanyAccount = {
  base: () => 'companyAccount' as const,
  get: (companyAccountId: UUID | undefined) =>
    [queryKeysCompanyAccount.base(), 'detail', { companyAccountId }] as const,
  getAllAdmin: (queryParams: Record<string, unknown> = {}) =>
    [queryKeysCompanyAccount.base(), 'list', 'admin', queryParams] as const,
  getDeletionCheck: ({ companyAccountId }: { companyAccountId: UUID }) =>
    [
      queryKeysCompanyAccount.base(),
      'deletionCheck',
      { companyAccountId },
    ] as const,
  getSupplierLetter: (companyAccountId: UUID) =>
    [
      queryKeysCompanyAccount.base(),
      'detail',
      'supplierLetter',
      { companyAccountId },
    ] as const,
  getSupplierLetterOverrides: (companyAccountId: UUID) =>
    [
      queryKeysCompanyAccount.base(),
      'detail',
      'supplierLetter',
      'overrides',
      { companyAccountId },
    ] as const,
  getSupplierLetters: () =>
    [queryKeysCompanyAccount.base(), 'detail', 'supplierLetter'] as const,
} as const;
